import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { ThemeProvider } from '@mui/material/styles';
import theme from '../../theme/theme';
import useStore from '../../store/useStore';

import SearchBarSessions from '../filters/SearchBarSessions';
import SearchBarMySessions from '../filters/SearchBarMySessions';
import FilterBarSessions from '../filters/FilterBarSessions';

import BannerComponent from '../banner';

import CardViewSessions from './CardViewSessions';
import ListViewSessions from './ListViewSessions';
import BannerEventSessions from './BannerEventSessions';

const HomeSessions = () => {
  const {
    updateSettings,
    updateData,
    filters,
    GetCurrentSessions,
    GetEventSessions,
    GetMySessions,
    changeEventID,
    eventId,
    MySessions,
    darkTheme,
    hideheader,
    view
    //view /*filters, view, settings*/
  } = useStore((state: any) => ({
    updateSettings: state.updateSettings,
    updateData: state.updateData,
    filters: state.filters,
    GetCurrentSessions: state.GetCurrentSessions,
    GetEventSessions: state.GetEventSessions,
    GetMySessions: state.GetMySessions,
    changeEventID: state.changeEventID,
    eventId: state.settings.params.eventid,
    MySessions: state.filters.MySessions,
    darkTheme: state.settings.params.darkTheme,
    hideheader: state.settings.params.hideheader,

    //gridData: state.MUIdata,
    view: state.settings.params.view
    //filters: state.filters,
    //settings: state.settings
  }));

  //const view = useStore((store: any) => store.view);

  // Here we retrieve the url parameter with useParams()
  // const { eventId } = useParams();

  // And then we update the state eventId
  //watch changes to eventId
  useEffect(() => {
    //set eventID value and rebuild data
    changeEventID(eventId);

    //reload data
    const getData = async () => {
      if (eventId !== undefined && eventId !== '') {
        await GetEventSessions(); //call geteventsessions if eventid is available
      } else if (MySessions !== undefined && MySessions == 1) {
        //get logged-in sessions
        console.log('mysessions: ' + MySessions);

        await GetMySessions();
      } else {
        await GetCurrentSessions();
      }
    };

    getData();
  }, [eventId, MySessions]);

  const getTitleBanner = () => {
    if (filters.MySessions == 0) return 'Daily Schedule';
    else if (filters.MySessions == 1) return 'My Sessions';
    else return '';
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        {darkTheme === '0' && eventId !== '' && eventId !== undefined ? (
          <>
            <br />
            <BannerEventSessions />
          </>
        ) : (
          <></>
        )}

        {hideheader === '0' && darkTheme === '1' ? (
          <BannerComponent title={getTitleBanner()} />
        ) : (
          <></>
        )}

        {/* display Search bar component */}
        {darkTheme === '0' && eventId !== '' && eventId !== undefined ? (
          <SearchBarMySessions />
        ) : (
          <SearchBarSessions />
        )}

        {/* display Filters component */}
        <FilterBarSessions />

        {/* display sessions Data grid component */}
        {view === 'card' ? <CardViewSessions /> : <ListViewSessions />}
      </div>
    </ThemeProvider>
  );
};

export default HomeSessions;
